module.exports = __webpack_public_path__ + "img/inshore.76c04878.jpeg";